import { signInWithGoogle } from '../registration/firebase.js';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as GoogleIcon } from '../../Imagines/GoogleLogo.svg';
import '../../CSS/SignInButton.css';
import { useTranslation } from "react-i18next";

const SignInButton = () => {

    const translation = useTranslation('mainPage');
    /** @type {any} */
    const t = translation.t;

    const navigate = useNavigate();


    const handleGoogleSignIn = () => {
        signInWithGoogle()
            .then((userData) => {
                fetchLoginData(userData);  // Use userData after successful sign-in
            })
            .catch((error) => {
                console.error('Error during Google sign-in:', error);
                // Handle the error appropriately (e.g., show an error notification)
            });
    };

    const fetchLoginData = (userData) => {

        localStorage.setItem('uid', userData.uid);
        localStorage.setItem('email', userData.email);
        localStorage.setItem('photoURL', userData.photoURL);
        localStorage.setItem('providerId', userData.providerData[0].providerId);

        const requestData = {
            uid: userData.uid,
            email: userData.email,
            photoURL: userData.photoURL,
            providerId: userData.providerData[0].providerId,
            referralCode: localStorage.getItem('promo'),
            period: localStorage.getItem('period'),
            tariff: localStorage.getItem('tariff'),
            ...(localStorage.getItem('userID') && { prepaidToken: localStorage.getItem('userID') }),
        };

        fetch(`https://gostlink.ru/api/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestData),
        })
            .then(response => {
                console.log(response);
                return response.text();
            })
            .then(text => {
                console.log(text);  // Log the raw text response
                if (text) {
                    return JSON.parse(text);
                }
                return {};
            })
            .then(data => {
                console.log(data);
                if (data.success) {
                    localStorage.setItem('expirationDate', data.expirationDate);
                    localStorage.setItem('subscriptionIsActive', data.subscriptionIsActive);
                    localStorage.setItem('isYandexAuth', "false");

                    if (data.subscriptionIsActive === true){
                        navigate(`/profile`);
                    } else {
                        navigate(`/profile`);
                    }

                } else {
                    navigate(`/`);
                }
            })
            .catch(error => {
                console.error('Fetch error:', error);
                navigate(`/`);
            });
    };

        return (
            <button className="RegistrationButton" onClick={handleGoogleSignIn}>
                <div className='RegistrationBlock_logo'>
                    <GoogleIcon/>
                </div>
                <p>{t('Registration.Google')}</p>
            </button>
        )
};

export default SignInButton;
